export default function($) {
  var speed = 90, // ms
      $wpAdminBar = $('#wpadminbar');

  $('.js-nav-mobile-button').click(function () {
    if($('.js-nav-items').hasClass('nav-items-open')) {
      $('.js-nav-items').slideUp(speed);
      $('.js-nav-items').css({
        'top': '0',
        'height': 'auto',
        'overflow-y': 'visible'
      });
      $('.js-nav-items').removeClass('nav-items-open');
      $('body').removeClass('h-screen');
      $('body').removeClass('overflow-hidden');
      $(this).removeClass('nav-trigger-active');
    } else {
      if ($wpAdminBar.length) {
        var topPos = $('header').outerHeight() + $wpAdminBar.outerHeight();
      } else {
        var topPos = $('header').outerHeight();
      }
      $('.js-nav-items').css({
        'top': topPos+'px',
        'height': 'calc(100vh - '+topPos+'px)',
        'overflow-y': 'auto'
      });
      $('.js-nav-items').slideDown(speed);
      $('.js-nav-items').addClass('nav-items-open');
      $('body').addClass('h-screen');
      $('body').addClass('overflow-hidden');
      $(this).addClass('nav-trigger-active');
    }
  });

  $('.menu-item-has-children').click(function (event) {
    if ($(window).width() < 1024) {
      event.stopPropagation();
      $(this).siblings('.menu-item-has-children--active').each(function(i, sibling) {
        $(sibling).removeClass('menu-item-has-children--active').children('.sub-menu').slideUp(speed);
      });
      $(this).children('.sub-menu').slideToggle(speed);
      $(this).toggleClass('menu-item-has-children--active');
    }
  });

  $(document).click(function(event) {
    if (!$(event.target).closest('.js-nav').length) {
      if ($(window).width() < 1024 && $('.sub-menu').is(":visible")) {
        $('.sub-menu').slideUp(speed);
        $('.menu-item-has-children--active').removeClass('menu-item-has-children--active');
      }
      if($('.js-nav-items').hasClass('nav-items-active')) {
        $('.js-nav-items').slideUp(speed);
        $('.js-nav-items').removeClass('nav-items-active');
        $('.js-nav-mobile-button').removeClass('nav-trigger-active');
      }
    }
  });

  $(window).resize(function() {
    if( $(window).width() >= 1024 ) {
      $('.js-nav-items').css({
        'display': 'flex',
        'top': '0',
        'height': 'auto',
        'overflow-y': 'visible'
      });
      $('.js-nav-items').removeClass('nav-items-open');
      $('body').removeClass('h-screen');
      $('body').removeClass('overflow-hidden');
      $('.js-nav-mobile-button').removeClass('nav-trigger-active');
    } else {
      $('.js-nav-items').css({
        'display': 'none',
        'top': '0',
        'height': 'auto',
        'overflow-y': 'visible'
      });
      $('.js-nav-items').removeClass('nav-items-active');
      $('.js-nav-mobile-button').removeClass('nav-trigger-active');
    }
  })

  $(window).scroll(function() {
    if ($(this).scrollTop() >= 100) {
      $('.js-backtotop').fadeIn();
    } else {
      $('.js-backtotop').fadeOut();
    }
    const $header = $('.js-header-scroll');
    const $headerLogo = $('.header-logo');
    const $headerLogoWhite = $('.header-logo-white');
    const $navTrigger = $('.js-nav-mobile-button svg');
      if ($header.length && $(window).width() < 768) {
        const scrollTop = $(this).scrollTop();
        const threshold = $(window).height() - 148;
        if (scrollTop > threshold) {
          $header.removeClass('bg-white/10').addClass('bg-white');
          $headerLogo.removeClass('hidden').addClass('block');
          $headerLogoWhite.removeClass('block').addClass('hidden');
          $navTrigger.css('fill', '#424242');
        } else {
          $header.removeClass('bg-white').addClass('bg-white/10');
          $headerLogo.removeClass('block').addClass('hidden');
          $headerLogoWhite.removeClass('hidden').addClass('block');
          $navTrigger.css('fill', '#ffffff');

        }
      }
  });
}
